import { render, staticRenderFns } from "./complianceInd.vue?vue&type=template&id=f7fa98b4"
import script from "./complianceInd.vue?vue&type=script&lang=js"
export * from "./complianceInd.vue?vue&type=script&lang=js"
import style0 from "./complianceInd.vue?vue&type=style&index=0&id=f7fa98b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports